import { GlobalStatus } from "@gtpl/shared-models/common-models";
import { DocumentsEnum } from "@gtpl/shared-models/logistics";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class UpdateSoInspectionInfo{
    @ApiProperty()
    soInspectionId?:number;
    @ApiProperty()
    inspectionName: string;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty({ enum: Object.values(GlobalStatus) })
    @IsNotEmpty()
    isChecked:GlobalStatus;
}